<div class="container">
  <div class="container__background"></div>
  <div class="container__content">
    <div class="content">
      <div class="content__text">
        <div class="text">
          <p class="text__item">特別なプレゼントと</p>
          <p class="text__item">特別な体験を</p>
          <br />
          <p class="text__description">贈る人の想いがこもった</p>
          <p class="text__description">特別な時間をお届けします</p>
          <br /><br class="br" />
          <p class="text__underline">
            <a
              routerLink="/about"
              class="button"
              >セカイチについて</a
            >
          </p>
        </div>
      </div>
      <!--      <div class="content__button">-->
      <!--        <lib-button-->
      <!--          color="accent-alt"-->
      <!--          size="sm"-->
      <!--          (buttonClick)="onButtonClick()"-->
      <!--          ><b>絵本の一覧を見る</b></lib-button-->
      <!--        >-->
      <!--      </div>-->
    </div>
  </div>
</div>
